import React from "react";
import openDays from "../../assets/images/logo-open-days.webp";
import porto215 from "../../assets/images/logo-porto-215.webp";
import comPortuaria from "../../assets/images/logo-com-portuaria.webp";
import SocialIcons from "../../components/SocialIcons/SocialIcons";

import "./footer.css";

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <section className="footer__container">
      <footer className="footer__content content__page">
        <div className="logos-footer">
          <a href="#header-215" target="_blank" rel="noreferrer">
            <img src={openDays} alt="Porto de Aveiro - Open Days 215 anos" />
          </a>
          <a href="https://portodeaveiro.pt/" target="_blank" rel="noreferrer">
            <img src={porto215} alt="Porto de Aveiro - Open Days 215 anos" />
          </a>
          <a
            href="https://www.comunidadeportuariadeaveiro.pt/inicio"
            target="_blank"
            rel="noreferrer"
          >
            <img
              src={comPortuaria}
              alt="Porto de Aveiro - Open Days 215 anos"
            />
          </a>
        </div>
        <SocialIcons />
        <div className="copy">
          <p>
            Desenvolvido pela{" "}
            <a
              href="https://creative-minds.pt/"
              target="_blank"
              rel="noreferrer"
            >
              Creative Minds{" "}
            </a>{" "}
            {year}
          </p>
        </div>
      </footer>
    </section>
  );
};

export default Footer;
